import { render } from "./OnlineSaleNotificationEmails.vue?vue&type=template&id=338bed38&scoped=true"
import script from "./OnlineSaleNotificationEmails.vue?vue&type=script&lang=js"
export * from "./OnlineSaleNotificationEmails.vue?vue&type=script&lang=js"

import "./OnlineSaleNotificationEmails.vue?vue&type=style&index=0&id=338bed38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338bed38"]])

export default __exports__